/* eslint-disable @typescript-eslint/member-ordering */
/// <reference types="@types/jquery" />
/// <reference types="@types/slick-carousel" />
import { Component, OnInit, HostListener, AfterViewInit, ViewChild, ElementRef, OnDestroy, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {
  Color, BrandModel, Type, PreProcessSettings,
  Category, Region, Classification, Contract, MessageModal, Regulation, Lot, User, Vehicle, Situation
} from 'src/app/core/models';
import {
  ReasonService, AlertService, ModalService, ColorService, PreProcessSettingsService,
  TypeService, CategoryService, BrandModelService, ClassificationService, StorageService,
  StorageKey, ContractService, ProcessViolationService, RegulationService, LotService, UserService
} from 'src/app/core/services';
import { ClosedModalError } from 'src/app/core/errors';
import { CommentPanelComponent } from '../comment-panel/comment-panel.component';
import { SearchPlatePanelComponent } from '../search-plate-panel/search-plate-panel.component';
import { PlateService } from 'src/app/core/services/plate.service';
import { City } from 'src/app/core/models/City';
import { CityService } from 'src/app/core/services/city.service';
import * as _ from 'lodash';
import { RegionService } from 'src/app/core/services/region.service';
import { StateService } from 'src/app/core/services/state.service';
import { State } from 'src/app/core/models/State';
import { SelectRegulationModalComponent } from 'src/app/modals/select-regulation-modal/select-regulation-modal.component';
import { Violation, AlertType, AlertItem, ComponentModal, } from 'src/app/core/models';
import { ViolationService } from 'src/app/core/services/violation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { isEqual, cloneDeep } from 'lodash';
import {
  MessageDuplicateViolationModalComponent
} from 'src/app/modals/message-duplicate-violation-modal/message-duplicate-violation-modal.component';
import { ViolationFilter } from 'src/app/core/interface/ViolationFilter';
import { BrandInternal } from 'src/app/core/models/BrandInternal';
import { BrandInternalService } from 'src/app/core/services/brandInternal.service';
import {
  MessageVehicleWhiteListModalComponent
} from 'src/app/modals/message-vehicle-white-list-modal/message-vehicle-white-list-modal.component';
import { HistoryPanelComponent } from '../history-panel/history-panel.component';

@Component({
  selector: 'app-process-audit',
  templateUrl: './process-audit.component.html',
  styleUrls: ['./process-audit.component.sass']
})
export class ProcessAuditComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('reasonInput', { static: false }) reasonInput: ElementRef;

  get plateInputElement() {
    return this._plateInputElement;
  }
  @ViewChild('plateInputElement', { static: false }) set plateInputElement(content) {
    if (content == null) {
      this._plateInputElement = content;
      return;
    }
    if (this._plateInputElement != null) {
      return;
    }
    this._plateInputElement = content;
  }
  public allowEditAudit: boolean;
  public _plateInputElement;
  public plateInput: HTMLInputElement;
  public formGroup: FormGroup;
  public violation: Violation = new Violation();
  public violations: Violation[] = [];
  public preProcessSettings: PreProcessSettings;
  public i = 0;
  public files = [];
  public secondFiles = [];
  public reasons = [];
  public reasonsAll = [];
  public types: Array<Type>;
  public colors: Array<Color>;
  public brandModels: Array<BrandModel>;
  public brandInternalModels: Array<BrandInternal>;
  public cities: Array<City>;
  public categories: Array<Category>;
  public regions: Array<Region>;
  public states: Array<State>;
  public classifications: Array<Classification>;
  public showingCities: Array<City>;
  public filters: ViolationFilter;
  public showingStates: Array<State>;
  public requiredFields = [];
  public hasSearch = false;
  public validatorsDisabled = false;
  public imagesSettings: {
    [type: string]: {
      blur: { positions: [{ width: number; height: number; x: number; y: number }] };
      contrast: number; brightness: number; restore?: boolean;
    };
  };
  public isBlurEnabled = false;
  public isClipEnabled = false;
  public contractId = '';
  public refuseLoading = false;
  public acceptLoading = false;
  public violationsSteps = null;
  public regionId = null;
  public stateTextCities;
  public sessionId = null;
  public violationIdsProcessed = [];
  public isLoadListViolation = false;
  public violationLoadError = false;
  public changesPermited = true;
  public violationProcessed = false;
  public isChangePlate = false;
  public formEdited = false;
  public regulationByIds: { [params: string]: Regulation } = {};
  public isSearchPlate = true;
  public vehicleData: Vehicle;
  public cetModels = false;
  public lotData: Lot;
  public usersById: { [params: string]: User } = {};
  public currentUser: User;
  public whitelistReasonCode = null;
  public loading = false;
  public internalAuditView = false;
  public counterAudited = 0;
  public counterRefused = 0;
  public counterValid = 0;
  public situation = Object.keys(Situation);
  public situationI18n = [];
  public lotSituation = '';

  private loadPromise = null;
  private limit = '5';
  private next = null;
  private isDouble = false;
  private isSingleView;
  private isDoubleView;
  private modalState;
  private isModified = false;
  private stepGroup;
  // eslint-disable-next-line @typescript-eslint/ban-types
  private plateSearched: { vechicle: {} };
  private plateRegex = null;
  private contract: Contract = null;
  private timeoutId = null;
  private expired = false;
  private placeDebouncer = null;
  private plateSearchPromise = null;
  private plateSearchFoundFields = [];
  private plateFound = true;
  private disabledRequiredFields: { [params: string]: any } = {};

  @Output() violationStatus: string;

  constructor(
    private formBuilder: FormBuilder,
    public activatedRoute: ActivatedRoute,
    private router: Router,
    private violationService: ViolationService,
    private reasonService: ReasonService,
    private modalService: ModalService,
    private preProcessSettingsService: PreProcessSettingsService,
    private alertService: AlertService,
    private plateService: PlateService,
    private colorService: ColorService,
    private typeService: TypeService,
    private categoryService: CategoryService,
    private brandModelService: BrandModelService,
    private classificationService: ClassificationService,
    private cityService: CityService,
    private regionService: RegionService,
    private storageService: StorageService,
    private stateService: StateService,
    private contractService: ContractService,
    private processViolationService: ProcessViolationService,
    private regulationService: RegulationService,
    private brandInternalService: BrandInternalService,
    private lotService: LotService,
    private userService: UserService
  ) { }

  async ngOnInit() {
    if (localStorage.getItem('internalAuditView')) {
      this.internalAuditView = true;
    }
    this.loading = true;
    this.contractId = this.activatedRoute.snapshot.params.contractId;
    this.currentUser = this.storageService.get(StorageKey.currentUser);
    const windowState = window.history.state || {};

    /**
     * @description
     * use this parameter to validate if the screen access is viewing or editing
     */
    this.allowEditAudit = windowState.allowEditAudit;

    await this.getLotData();
    await this.getUsers();
    this.processViolationService.getFilterProcessViolation()
      .pipe()
      .subscribe((result: any) => this.filters = result);
    if (this.filters === null) {
      this.router.navigate([`../../../pre-process`], { relativeTo: this.activatedRoute });
    }
    this.setInactivity();
    const promises = [];
    promises.push(this.contractService.getById(this.contractId));
    this.preProcessSettingsService.getById(this.contractId).then(preProcessSettings => {
      this.preProcessSettings = preProcessSettings;
      this.requiredFields = preProcessSettings.requiredFields || [];
      this.requiredFields.forEach(field => {
        this.disabledRequiredFields[field] = true;
      });
      this.hasSearch = preProcessSettings.vehicleDataSearch !== 'disabled';
      this.isBlurEnabled = this.preProcessSettings.imageEdit.blur;
      this.isClipEnabled = this.preProcessSettings.imageEdit.clip;
      this.violationsSteps = this.preProcessSettings.violationSteps;
      this.reasonService.getAll({
        contractId: this.contractId,
        order: 'code',
        'enabled[bool]': 'true',
        'screen[contains]' : 'audit'
      }).then(data => {
        this.reasons = data.sort((a, b): any => Number(a.code) - Number(b.code));
        this.reasonsAll = this.reasons;
        if (this.preProcessSettings?.whitelistReasonId != null) {
          const reason = this.reasons.find(r => r.id === this.preProcessSettings.whitelistReasonId);
          this.whitelistReasonCode = reason?.code;
        }
      });

      this.setRequiredFields();
    });

    promises.push(this.regionService.getAll().then(regions => {
      this.regions = regions;
      this.stateService.getAll({ regionId: regions[0].id }).then(states => {
        this.states = states;
        this.showingStates = states;
      }).catch(error => {
        console.error(error);
      });
      this.cities = this.storageService.get(StorageKey.cities) || [];
      if (this.cities.length === 0) {
        this.cityService.getAll({ regionId: this.regions[0].id }).then(res => {
          this.cities = _.sortBy(res, 'name');
        }).catch(error => {
          console.error(error);
        });
      } else {
        let cities = [];
        Object.keys(this.cities).map(stateId => {
          cities = cities.concat(this.cities[stateId]);
        });
        this.cities = _.sortBy(cities, 'name');
        return regions;
      }
      return regions;
    }).catch(error => {
      console.error(error);
    }));
    const routeCurrent = this.activatedRoute.snapshot.url[0] || { path: '' };
    this.createForm();
    this.stepGroup = routeCurrent.path;
    await this.getViolations(true).catch(err => { });
    await Promise.all(promises).then(results => {
      const contract = results[0];
      this.regionId = contract.regionId;
      const regions = results[1];
      const region = regions.find(r => r.id === contract.regionId);
      this.colorService.getAll({ regionId: region.id }).then(colors => {
        this.colors = colors;
      });
      this.typeService.getAll({ regionId: region.id }).then(types => {
        this.types = types;
      });
      this.categoryService.getAll({ regionId: region.id }).then(categories => {
        this.categories = categories;
      });
      this.classificationService.getAll({ regionId: region.id }).then(classifications => {
        this.classifications = classifications;
      });
      let regulationParams = {};
      if (contract.regulationIds) {
        regulationParams = { regionId: contract.regionId, 'id[in]': `[${contract.regulationIds}]` };
      } else {
        regulationParams = { regionId: contract.regionId };
      }
      this.regulationService.getAll(regulationParams).then(regulations => {
        regulations.map(regulation => {
          if (this.regulationByIds[regulation.id] == null) {
            this.regulationByIds[regulation.id] = regulation;
          }
        });
      });
      if (region == null) {
        return;
      }
      this.plateRegex = region.plateRegex;
      if (this.formGroup != null) {
        const plateControl = this.formGroup.get('plate');
        plateControl.setValidators([plateControl.validator, Validators.pattern(this.plateRegex)]);
      }
    });
    this.loading = false;
    this.lotSituation = this.situationI18n.find(s => s.id === this.lotData?.situation)?.value;
  }

  async getLotData() {
    const lotId = this.activatedRoute.snapshot.params.lotId;
    /**
     * @todo create service lock lot user if this.allowEditAudit is true
     */
    await this.lotService.getById(lotId, true).then(res => {
      this.lotData = res;
      this.updateCountersAudit(this.lotData.audits || []);
    });
  }

  async updateCountersAudit(audits = []) {
    this.counterAudited = audits.reduce((acc, obj) => acc + obj.totalAudited, 0) || 0;
    this.counterRefused = audits.reduce((acc, obj) => acc + obj.refusedAmount, 0) || 0;
    this.counterValid = this.counterAudited - this.counterRefused;

  }

  async getUsers() {
    await this.userService.getAll().then(res => {
      res.map(user => {
        this.usersById[user.id] = user;
      });
    });
  }

  ngOnDestroy(): void {
    this.lotData.lockUserId = 0;
    this.lotData.lockDate = '0000-00-00T00:00:00.000Z';
    if (this.lotData.situation === '') {
      delete this.lotData.situation;
    }
    this.lotService.update(this.lotData);
    const user = this.storageService.get(StorageKey.currentUser);
    if (user == null || user.id == null) {
      return;
    }
    if (this.lotData?.audits?.length > 0) {
      this.updateCountersAudit(this.lotData.audits);
      if (this.counterAudited === this.lotData?.violationsAmount) {
        this.lotData.situation = 'accepted';
        this.lotService.accept(this.lotData).then(() => {
          this.alertService.show(new AlertItem('AuditSaved', AlertType.success, false, 2000));
        });
      }
    }

    const userId = user.id;
    const violationIds = this.violations.map(v => v.id);
    this.violationService.unlock(userId, violationIds);
    clearTimeout(this.timeoutId);
    if (localStorage.getItem('internalAuditView')) {
      localStorage.removeItem('internalAuditView');
    }
  }

  unlock() {
    const user = this.storageService.get(StorageKey.currentUser);
    const violationIds = this.violations.map(v => v.id);
    this.violationService.unlock(user.id, violationIds);
  }

  editEvent(key) {
    const oldValue = this.violation.vehicle[key];
    const newValue = this.formGroup.get(key).value;
    if (oldValue !== newValue) {
      this.formEdited = true;
    } else {
      this.formEdited = false;
    }
  }

  ngAfterViewInit(): void { }

  getQueryParams() {
    const queryParams: any = {
      contractId: this.contractId,
      lock: 'false',
      limit: this.limit
    };
    queryParams['lotIdAudit[in]'] = `[${this.activatedRoute.snapshot.params.lotId}]`;
    if (this.filters.hasOwnProperty('equipmentsIds') && this.filters.equipmentsIds) {
      queryParams['equipment.id[in]'] = `[${this.filters.equipmentsIds}]`;
    }
    if (this.filters.hasOwnProperty('laneIds') && this.filters.laneIds) {
      queryParams['laneCode[in]'] = `[${this.filters.laneIds.join()}]`;
    }
    if (this.filters.hasOwnProperty('regulationsIds') && this.filters.regulationsIds) {
      queryParams['regulationId[in]'] = `[${this.filters.regulationsIds.join()}]`;
    }
    if (this.filters.hasOwnProperty('startDate') && this.filters.startDate) {
      queryParams['date[gte]'] = this.filters.startDate;
    }
    if (this.filters.hasOwnProperty('endDate') && this.filters.endDate) {
      queryParams['date[lte]'] = this.filters.endDate;
    }
    queryParams.order = 'date';
    return queryParams;
  }

  backToFilter() {
    this.processViolationService.emitFilterProcessViolation(null);
    this.router.navigate([`../../${this.stepGroup}`], { relativeTo: this.activatedRoute, queryParams: { contractId: this.contractId } });
  }

  getViolations(isFirst = false, isRetry = false) {
    this.loading = true;
    this.violationLoadError = false;
    if (this.loadPromise) {
      return this.loadPromise;
    }
    const queryParams = this.getQueryParams();
    if (!this.internalAuditView && isFirst && this.violations.length === 0) {
      this.loadPromise = this.violationService.getLockedViolationsByMe(null, queryParams).then(async data => {
        let next = data.next;
        if (next == null && data.result.length === 0) {
          this.isLoadListViolation = true;
          this.isSearchPlate = true;
          return this.loadPromise = this.violationService.list(queryParams).then(item => {
            this.next = item.next;
            this.isLoadListViolation = false;
            return item;
          });
        } else {
          while (next != null) {
            const nextData = await this.violationService.getLockedViolationsByMe(next, queryParams);
            if (nextData && nextData.result != null) {
              data.result = data.result.concat(nextData.result);
            }
            next = nextData && nextData.next;
          }
        }
        return data;
      }).catch(async err => {
        if (err.status === 404) {
          this.isLoadListViolation = true;
          this.loadPromise = this.violationService.list(queryParams).then(data => {
            this.next = data.next;
            this.isLoadListViolation = false;
            return data;
          });
        }
      });
    } else {
      if (this.next == null) {
        this.isLoadListViolation = true;
        this.loadPromise = this.violationService.list(queryParams).then(data => {
          this.next = data.next;
          this.isLoadListViolation = false;
          return data;
        });
      } else {
        this.loadPromise = this.violationService.list(this.next).then(data => {
          this.next = data.next;
          this.isLoadListViolation = false;
          return data;
        });
      }
    }
    if (this.lotData.violationsAmount !== this.violations.length) {
      return this.loadPromise.then(async data => {
        this.loadPromise = null;
        this.violations = this.violations.concat(data.result.filter(d => !this.violations.find(v => v.id === d.id)));
        let isSearchAgain = false;
        for (const v of this.violations) {
          const violation: any = v;
          if (this.violationIdsProcessed.includes(violation.id)) {
            isSearchAgain = true;
            continue;
          }
          if (violation.history.audits != null) {
            this.i++;
            this.violationIdsProcessed.push(violation.id);
            isSearchAgain = true;
            continue;
          }
          if (violation != null) {
            isFirst = false;
            this.setForm(violation);
            if (violation.vehicle && violation.vehicle.plate && violation.vehicle.plate !== '') {
              await this.loadVehicle(violation.vehicle.plate);
            }
            break;
          }
        }
        if (isFirst && isSearchAgain) {
          await this.getViolations(true).catch(err => { });
        }

        this.preloadFiles(data.result);
        if (this.i >= this.violations.length - 1) {
          this.alertService.show(new AlertItem('NoViolationsTyping', AlertType.danger));
        }
      }).catch(async err => {
        this.loadPromise = null;
        if (isRetry === false) {
          await this.getViolations(false, true).then(() => {
            this.i++;
            this.setForm(this.violations[this.i]);
          });
        } else {
          this.alertService.show(new AlertItem('ViolationListError', AlertType.danger));
          this.violationLoadError = true;
          console.error(err);
          throw err;
        }
      });
    }
  }

  getImageEdit(event) {
    if (event == null) {
      return;
    }
    this.imagesSettings = event;
  }

  get typingValid() {
    if (this.formGroup == null) {
      return false;
    }
    if (this.preProcessSettings != null &&
      this.preProcessSettings.allowInputNotFoundVehicle !== true &&
      this.plateFound === false) {
      return false;
    }
    const reasonControl = this.formGroup.get('reasonCode');
    if (reasonControl && reasonControl.value != null && reasonControl.value !== '') {
      return false;
    } else {
      return this.formGroup.valid;
    }
  }

  get validationPlate() {
    const plate = this.formGroup && this.formGroup.get('plate');
    const reason = this.formGroup && this.formGroup.get('reasonCode');
    if ((plate.value == null || plate.value === '') && reason.value !== '') {
      return true;
    }
    plate.setValidators([plate.validator, Validators.pattern(this.plateRegex)]);

    return !plate.invalid;
  }

  loadMoreViolations() {
    if (this.loadPromise != null) {
      return this.loadPromise;
    }
    const queryParams = this.getQueryParams();
    this.loadPromise = this.violationService.list(queryParams).then(data => {
      this.loadPromise = null;
      this.violations = this.violations.concat(data.result);
      this.preloadFiles(data.result);
      if (this.i >= this.violations.length - 1) {
        this.alertService.show(new AlertItem('NoViolationsTyping', AlertType.danger));
      }
    }).catch(err => {
      this.loadPromise = null;
      throw err;
    });
    return this.loadPromise;
  }

  preloadFiles(violations) {
    setTimeout(() => {
      const violation = violations.shift();
      if (violation && violation.files != null) {
        violation.files.forEach(f => {
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.src = f.urlCurrent || f.urlDecrypted;
        });
      }
      if (violations.length > 0) {
        this.preloadFiles(violations);
      }
    }, 50);
  }

  get form() {
    return this.formGroup.controls;
  }

  createForm() {
    this.formGroup = this.formBuilder.group({
      plate: ['', [Validators.pattern(this.plateRegex)]],
      colorCode: [''],
      year: [''],
      brandModelCode: [''],
      categoryCode: [''],
      classificationCode: [''],
      typeCode: [''],
      cityCode: [''],
      stateId: [''],
      regionCode: [''],
      regionId: ['Brasil'],
      reasonCode: ['']
    });
    this.formGroup.valueChanges.subscribe(value => {
      this.isModified = true;
      this.editEvent('plate');
    });
    this.formGroup.get('reasonCode').valueChanges.subscribe(value => {
      const textRequired = value !== '' ? '' : 'Este campo é requerido.';
      if (value == null || value === '') {
        this.setRequiredFields();
      } else {
        this.disableValidators();
      }
      if (value) {
        const element = document.getElementById('plateInputElement') as HTMLElement;
        if (element) {
          if (element.querySelector('.form-group .text-danger span')) {
            element.querySelector('.form-group .text-danger span').textContent = textRequired;
            if (value !== '') {
              element.querySelector('.form-group input')?.classList.remove('is-invalid');
            }
          }
        }
      }
    });
  }

  setForm(violation) {
    this.violation = violation;
    this.allowEditAudit = true;
    this.violationProcessed = false;
    this.isChangesPermited();
    this.setFiles(violation);
    this.formGroup.controls.cityCode.setValue(null);
    this.formGroup.controls.stateId.setValue(null);
    this.formGroup.controls.regionId.setValue(this.regionId);
    this.setFormPlate(violation.vehicle);
    const plateControl = this.formGroup.get('plate');
    plateControl.setValue(violation.vehicle.plate);
    this.formGroup.get('reasonCode').setValue((violation.reason && violation.reason.code) || '');
    this.formGroup.get('reasonCode').enable();
    if (violation.history.audits != null) {
      if (!this.violationIdsProcessed.includes(violation.id)) {
        this.violationIdsProcessed.push(violation.id);
      }
      this.formGroup.get('reasonCode').disable();
    }

    if (this.violationIdsProcessed.includes(violation.id)) {
      plateControl.setValue(violation.vehicle.plate);
    }

    for (const i in this.formGroup.controls) {
      if (this.formGroup.controls.hasOwnProperty(i)) {
        const control = this.formGroup.controls[i];
        control.markAsPristine();
      }
    }
    this.reasons = this.reasonsAll.filter(reason =>
      reason.regulationIds.includes(violation.regulationId));
    this.isModified = false;
  }

  setRequiredFields() {
    const controls = this.formGroup.controls;
    if (this.requiredFields == null || this.requiredFields.length === 0) {
      return;
    }
    Object.keys(controls).forEach(key => {
      if (this.requiredFields.includes(key)) {
        if (this.plateRegex != null && key === 'plate') {
          controls[key].setValidators([Validators.required, Validators.pattern(this.plateRegex)]);
        } else {
          controls[key].setValidators([Validators.required]);
        }
        controls[key].markAsDirty();
      } else {
        controls[key].clearValidators();
      }
      controls[key].updateValueAndValidity({ emitEvent: false });
    });
    this.validatorsDisabled = false;
  }

  disableValidators() {
    if (!this.validatorsDisabled) {
      Object.keys(this.formGroup.controls).forEach(control => {
        if (control !== 'plate') {
          this.formGroup.controls[control].clearValidators();
          this.formGroup.controls[control].updateValueAndValidity({ emitEvent: false });
        }
      });
      this.validatorsDisabled = true;
    }
  }

  setFiles(violation) {
    if (this.isDouble) {
      if (violation.files != null) {
        this.files = [];
        this.secondFiles = [];
        violation.files.forEach(f => {
          const obj = {
            src: f.urlCurrent || f.urlDecrypted,
            type: f.type,
            urlCurrent: f.urlCurrent,
            urlDecrypted: f.urlDecrypted,
            targeHeight: f.targeHeight,
            targePosition: f.targePosition
          };
          if (/zoom/.test(f.type)) {
            this.files.push(obj);
          } else if (/pan2/.test(f.type)) {
            this.secondFiles.unshift(obj);
          } else {
            this.secondFiles.push(obj);
          }
        });
        if (this.files.length !== 0 || this.secondFiles.length !== 0) {
          if (this.secondFiles.length === 0 && this.files.length > 1) {
            this.secondFiles.push(this.files.pop());
          }
          if (this.files.length === 0) {
            this.files.push(this.secondFiles.shift());
          }
        }
      }
    } else {
      this.files = [];
      violation.files.forEach(f => {
        const file = {
          src: f.urlCurrent || f.urlDecrypted,
          type: f.type,
          urlCurrent: f.urlCurrent,
          urlDecrypted: f.urlDecrypted,
          targeHeight: f.targeHeight,
          targePosition: f.targePosition
        };
        if (f.type === 'zoom') {
          this.files.unshift(file);
        } else {
          this.files.push(file);
        }
      });
    }
  }

  getViolation() {
    let violation = cloneDeep(this.violation);
    if (violation.vehicle == null) {
      violation = Object.assign(violation, { vehicle: {} });
    }
    violation.vehicle.plate = this.formGroup.get('plate').value &&
      this.formGroup.get('plate').value.toUpperCase();
    violation.vehicle.colorCode = this.formGroup.get('colorCode').value;
    violation.vehicle.year = this.formGroup.get('year') &&
      this.formGroup.get('year').value && parseInt(this.formGroup.get('year').value, 10);
    violation.vehicle.brandModelCode = this.formGroup.get('brandModelCode').value;
    violation.vehicle.categoryCode = this.formGroup.get('categoryCode').value;
    violation.vehicle.classificationCode = this.formGroup.get('classificationCode').value;
    violation.vehicle.typeCode = this.formGroup.get('typeCode').value;
    violation.vehicle.cityCode = this.formGroup.get('cityCode').value;
    return this.removeVehicleFields(violation, ['length', 'profile', 'size', 'plateOCR']);
  }

  removeVehicleFields(violation, immutableFields: string[] = ['length', 'profile', 'size', 'plateOCR']) {
    const discardFields = ['brandModel', 'category', 'city',
      'classification', 'color', 'registrationNumber',
      'type', 'uf', null, 'undefined', ''];
    for (const key of Object.keys(violation.vehicle)) {
      if (immutableFields.includes(key)) {
        continue;
      }
      if (discardFields.includes(violation.vehicle[key])) {
        delete violation.vehicle[key];
      }
      if (['renavam', 'modelYear'].includes(key) && this.formGroup.get('plate').value === '') {
        delete violation.vehicle[key];
      }
    }
    return violation;
  }

  setDouble(flag) {
    if (this.isDouble !== flag) {
      this.isDouble = flag;
      this.setFiles(this.violation);
    }
  }

  async nextViolation() {
    this.isChangePlate = false;
    if (this.imagesSettings != null) {
      await this.updateImages();
    }
    if (this.i < this.violations.length - 1) {
      this.i++;
      this.setForm(this.violations[this.i]);
      if (this.i > this.violations.length - 5) {
        this.getViolations().catch(err => { });
      }
    } else {
      const current = this.i;
      this.getViolations().then(() => {
        if (current < this.violations.length - 1) {
          this.i = current + 1;
        }
      }).catch(err => { });
    }
  }

  async lastViolation() {
    this.isChangePlate = false;
    if (this.imagesSettings != null) {
      await this.updateImages();
    }
    this.i = this.violations.length - 1;
    this.setForm(this.violations[this.violations.length - 1]);
  }

  async firstViolation() {
    this.isChangePlate = false;
    if (this.imagesSettings != null) {
      await this.updateImages();
    }
    this.i = 0;
    this.setForm(this.violations[0]);
  }

  async prevViolation() {
    this.isChangePlate = false;
    if (this.imagesSettings != null) {
      await this.updateImages();
    }
    if (this.i > 0) {
      this.i--;
      this.setForm(this.violations[this.i]);
    }
  }

  async validate() {
    if (this.acceptLoading === true) {
      return;
    }
    this.acceptLoading = true;
    const violation = this.getViolation();
    try {
      await this.violationService.accept(violation).then(violationProc => {
        this.violations[this.i] = violationProc;
      });
      this.violationIdsProcessed.push(violation.id);
      this.alertService.show(new AlertItem('ViolationSaved', AlertType.success, false, 2000));
      try {
        await this.lotService.getById(this.lotData.id, true).then(async lot => {
          this.lotData = lot;
          this.updateCountersAudit(this.lotData.audits);
          if (this.counterAudited === this.lotData?.violationsAmount) {
            lot.situation = 'accepted';
            await this.lotService.accept(lot).then(() => {
              this.alertService.show(new AlertItem('AuditSaved', AlertType.success, false, 2000));
            });
            this.router.navigate(['../../' + this.contractId], { relativeTo: this.activatedRoute });
          }
        });
      } catch (err) {
        this.alertService.show(new AlertItem('AuditSaveError', AlertType.danger));
      }
    } catch (err) {
      if (err.error.type === 'laneDisabled') {
        this.alertService.show(new AlertItem('FramingNotEnabledForTrack', AlertType.danger));
        this.acceptLoading = false;
        return;
      }
      if (err.status === 409) {
        const duplicateViolation = err.error;
        this.openMessageDuplicateViolation(duplicateViolation);
      } else if (err.status === 403) {
        this.alertService.show(new AlertItem('ProcessAuditUnauthorized', AlertType.danger));
      } else if (err.status === 500) {
        this.alertService.show(new AlertItem('ProcessedViolationAlreadyExists', AlertType.danger));
      } else {
        if (err.error && err.error.search('whiteList') > 0) {
          this.alertService.show(new AlertItem('ViolationSaveWhiteList', AlertType.danger));
        } else {
          this.alertService.show(new AlertItem('ViolationSaveError', AlertType.danger));
        }
        console.error(err);
      }
    }
    this.nextViolation();
    this.acceptLoading = false;
  }

  async updateImages() {
    const id = this.violation.id;
    for (const type of Object.keys(this.imagesSettings)) {
      const imageSettings = Object.assign({ type }, this.imagesSettings[type]);
      if (imageSettings.restore) {
        delete imageSettings.restore;
      }
      await this.violationService.updateImage(id, imageSettings)
        .then(data => {
          this.setFiles(data);
          this.alertService.show(new AlertItem('ViolationImageSaved', AlertType.success, false, 2000));
        })
        .catch((err) => {
          console.error(err);
          this.alertService.show(new AlertItem('ViolationImageSaveError', AlertType.danger));
        });
    }
    this.imagesSettings = null;
  }

  async restoreImage(type, imgSettings = null) {
    this.imagesSettings = imgSettings;
    await this.violationService.restoreImage(this.violation.id, { type })
      .then(data => {
        this.setFiles(data);
        this.alertService.show(new AlertItem('ViolationImageRestored', AlertType.success, false, 2000));
      })
      .catch((err) => {
        console.error(err);
        this.alertService.show(new AlertItem('ViolationImageRestoredError', AlertType.danger));
      });
  }

  async refused() {
    if (this.refuseLoading === true) {
      return;
    }
    this.refuseLoading = true;
    try {
      let violation = this.getViolation();
      const valueReason = this.formGroup.get('reasonCode').value;
      if (valueReason !== '') {
        const reason = this.reasons.find(r => r.code === valueReason);
        if (violation.reason == null) {
          violation = Object.assign(violation, { reason: {} });
        }
        if (this.changesPermited) {
          violation.reason = {
            code: reason.code,
            name: reason.name,
            type: reason.type || ''
          };
        }
      } else {
        delete violation.reason;
      }
      await this.violationService.refuse(violation).then(violationProc => {
        this.violations[this.i] = violationProc;
      });
      this.violationIdsProcessed.push(violation.id);
      this.alertService.show(new AlertItem('ViolationSaved', AlertType.success, false, 2000));
      try {
        await this.lotService.getById(this.lotData.id, true).then(async lot => {
          this.lotData = lot;
          this.updateCountersAudit(this.lotData.audits);
          if (this.counterAudited === this.lotData?.violationsAmount) {
            lot.situation = 'accepted';
            await this.lotService.accept(lot).then(() => {
              this.alertService.show(new AlertItem('AuditSaved', AlertType.success, false, 2000));
            });
            this.router.navigate(['../../' + this.contractId], { relativeTo: this.activatedRoute });
          }
        });
      } catch (err) {
        this.alertService.show(new AlertItem('AuditSaveError', AlertType.danger));
      }
      this.nextViolation();
    } catch (err) {
      if (err.status === 409) {
        const duplicateViolation = err.error;
        this.openMessageDuplicateViolation(duplicateViolation);
      } else if (err.status === 403) {
        this.alertService.show(new AlertItem('ProcessAuditUnauthorized', AlertType.danger));
      } else {
        this.alertService.show(new AlertItem('ViolationRefusedError', AlertType.danger));
        console.error(err);
      }
    }
    this.refuseLoading = false;
  }

  @HostListener('window:keydown', ['$event'])
  keyEvent(event) {
    const isCtrl = event.ctrlKey;
    switch (event.key) {
      case 'k':
        if (isCtrl) {
          this.prevViolation();
          event.preventDefault();
        }
        break;
      case 'l':
        if (isCtrl) {
          this.nextViolation();
          event.preventDefault();
        }
        break;
      case 'm':
        if (isCtrl) {
          if (this.modalService.isOpen(CommentPanelComponent)) {
            this.modalService.close();
          } else {
            this.openCommentPanel();
          }
          event.preventDefault();
        }
        break;
    }
    this.setInactivity();
  }

  @HostListener('window:mouseup', ['$event'])
  onMouseup(event: MouseEvent) {
    this.setInactivity();
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(e) {
    this.setInactivity();
  }

  openCommentPanel() {
    this.modalService.show(new ComponentModal(CommentPanelComponent, this.violation))
      .catch(err => { });
  }

  openSearchPlatePanel() {
    let data = null;
    this.modalService.show(new ComponentModal(SearchPlatePanelComponent, this.violation))
      .then((res: SearchPlatePanelComponent) => {
        data = res;
        this.vehicleData = data.component.instance.vehicleData;
        this.formGroup.get('plate').setValue(this.vehicleData.plate);
        this.formGroup.get('colorCode').setValue(this.colors.find(e => e.id === this.vehicleData.colorId).code);
        this.formGroup.get('year').setValue(this.vehicleData.year);
        this.formGroup.get('brandModelCode').setValue(data.component.instance.brandModelsById[this.vehicleData.brandModelId].code);
        this.formGroup.get('categoryCode').setValue(data.component.instance.categoryById[this.vehicleData.categoryId].code);
        this.formGroup.get('classificationCode')
          .setValue(data.component.instance.classificationById[this.vehicleData.classificationId].code);
        this.formGroup.get('typeCode').setValue(data.component.instance.typeById[this.vehicleData.typeId].code);
        this.loadCities(data.component.instance.cityById[this.vehicleData.cityId].stateId);
        this.setCoutry(data.component.instance.cityById[this.vehicleData.cityId], false);
      }).catch(err => { });
  }

  async setFormPlate(vehicle, isSearch = false) {
    if (vehicle?.brandModelCode != null) {
      this.brandModelService.getAll({ regionId: this.regionId || this.regions[0].id, code: vehicle.brandModelCode }).then(brandModels => {
        this.brandModels = brandModels;
      });
    }
    const items = ['color', 'classification', 'category', 'brandModel', 'type', 'city', 'year'];
    this.plateSearchFoundFields = [];
    items.forEach(async item => {
      const field = item === 'year' ? item : `${item}Code`;
      const value = item === 'year' ? 0 : '0';
      if (vehicle != null && vehicle[field]) {
        this.formGroup.get(field).setValue(vehicle[field]);
        if (vehicle[field] !== '' && vehicle[field] !== value && isSearch) {
          this.plateSearchFoundFields.push(field);
        } else if (this.violation.vehicle[field] != null &&
          (this.violation.vehicle[field] === '')) {
          delete this.violation.vehicle[field];
        }
      } else if (vehicle == null || vehicle[`${item}Id`] == null) {
        this.formGroup.get(field).setValue('');
      } else {
        const data = await this[`${item}Service`].getById(vehicle[`${item}Id`]);
        if (data != null) {
          this.formGroup.get(field).setValue(data.code);
          if (isSearch) {
            this.plateSearchFoundFields.push(field);
          }
        }
      }
    });
    if (vehicle != null) {
      let city;
      if (vehicle.cityId != null) {
        city = this.cities && this.cities.find(c => c.id === vehicle.cityId);
      } else {
        city = this.cities && this.cities.find(c =>
          c.regionId === this.regionId && c.code === vehicle.cityCode);
      }
      if (city == null) {
        if (vehicle.cityCode != null && vehicle.cityCode !== '') {
          await this.cityService.list({ regionId: this.regionId || this.regions[0].id, code: vehicle.cityCode })
            .then(async res => {
              city = res.result[0];
              await this.loadCities(city.stateId);
              await this.setCoutry(city, isSearch);
            });
        }
      } else {
        await this.loadCities(city.stateId);
        await this.setCoutry(city, isSearch);
      }
    }
  }

  async setCoutry(city, isSearch) {
    this.formGroup.get('cityCode').setValue(city.code);
    this.formGroup.get('regionId').setValue(city.regionId);
    this.formGroup.get('stateId').setValue(city.stateId);
    if (isSearch) {
      this.plateSearchFoundFields.push('cityCode');
      this.plateSearchFoundFields.push('regionId');
      this.plateSearchFoundFields.push('stateId');
    }
  }

  async loadVehicle(plateTyping: string, step = null) {
    const plateValue = this.formGroup.get('plate').value && this.formGroup.get('plate').value.toUpperCase();
    if (plateValue === this.violation.vehicle.plate) {
      return;
    }

    if (!plateTyping || plateTyping === '') {
      this.violation = this.removeVehicleFields(this.violation, ['length', 'profile', 'size', 'plateOCR']);
      this.resetForm();
    }

    if (this.hasSearch === true &&
      plateTyping &&
      plateTyping !== '' &&
      this.formGroup.get('plate').valid) {
      if (this.placeDebouncer != null) {
        clearTimeout(this.placeDebouncer);
      }

      this.placeDebouncer = setTimeout(async () => {
        this.plateSearchFoundFields = [];
        const params = {
          contractId: this.violation.contractId,
          plate: plateTyping,
          regulationId: this.violation.regulationId,
          date: this.violation.date
        };
        this.violation = this.removeVehicleFields(this.violation, ['length', 'profile', 'size', 'plateOCR']);
        if (plateValue !== this.violation.vehicle.plate) {
          this.violation.vehicle.plate = plateTyping;
          this.plateSearchPromise = this.findPlate(params);
        } else {
          this.setFormPlate(this.violation.vehicle, true);
        }
      }, 300);
    }
  }

  async findPlate(params: { contractId: string; plate: string; regulationId: string; date: Date }) {
    return this.plateService.searchPlate(params)
      .then((searchVehicle: any) => {
        this.setFormPlate(searchVehicle.vehicle, true);
        if (searchVehicle.vehicle == null) {
          this.violation = this.removeVehicleFields(this.violation);

          if (this.preProcessSettings != null && this.preProcessSettings.allowInputNotFoundVehicle !== true) {
            this.plateFound = false;
            this.isSearchPlate = true;
            this.alertService.show(new AlertItem(
              'PlateNotFoundNotAuthorized', AlertType.warning, false, 5000));
          } else {
            this.alertService.show(new AlertItem(
              'PlateNotFoundAuthorized', AlertType.warning, false, 5000));
          }
          this.resetForm();
          this.brandModelInternal();
          return;
        }
        this.plateFound = true;
        if (searchVehicle.vehicleWhiteList != null) {
          if (this.whitelistReasonCode != null) {
            this.formGroup.get('reasonCode').setValue(this.whitelistReasonCode || '');
          }
          searchVehicle.vehicleWhiteList.date = this.violation.date;
          this.modalService.show(new ComponentModal(MessageVehicleWhiteListModalComponent, searchVehicle.vehicleWhiteList))
            .then(data => {
            }).catch(err => { });
        }
      })
      .catch(err => {
        this.brandModelInternal();
        this.resetForm();
        if (this.preProcessSettings?.allowInputNotFoundVehicle) {
          this.violation.vehicle.plate = this.formGroup.get('plate').value && this.formGroup.get('plate').value.toUpperCase();
          this.setFormPlate(this.violation.vehicle, true);
        }
        return;
      });
  }

  async getBrandInternal() {
    const changeBrandModelForClientBrand = this.getValue(this.preProcessSettings, 'changeBrandModelForClientBrand');
    if (changeBrandModelForClientBrand) {
      this.cetModels = true;
      await this.brandInternalService.getAll().then(res => {
        res.map(brand => {
          brand.description = `${brand.code} - ${brand.description}`;
        });
        this.brandInternalModels = res;
      });
    }
  }

  getValue(model, attr, value = '') {
    let arr = [];
    if (typeof attr === 'string') {
      arr = attr.split('.');
    } else {
      arr = attr;
    }
    if (arr.length > 0) {
      if (model[arr[0]] == null) {
        return value;
      } else {
        return this.getValue(model[arr[0]], arr.slice(1), value);
      }
    } else {
      return model;
    }
  }

  async loadCities(stateId) {
    if (stateId == null || stateId === '') {
      this.showingCities = [];
      return;
    }
    this.showingCities = this.cities.filter(c => c.stateId === stateId);

    if (this.showingCities != null && this.showingCities.length === 0) {
      this.showingCities = await this.cityService.getAll({ regionId: this.regionId || this.regions[0].id, stateId });
      this.cities = this.cities.concat(this.showingCities);
    }
    this.showingCities = _.sortBy(this.showingCities, 'name');
    this.stateTextCities = true;
  }

  async loadStates(regionId) {
    this.showingStates = [];
    this.showingCities = [];
    if (!regionId) {
      return;
    }

    this.showingStates = this.states.filter(s => s.regionId === regionId);
    if (this.showingStates == null || this.showingStates.length === 0) {

      this.showingStates = await this.stateService.getAll({ regionId });
    }

  }

  setInactivity() {
    if (this.timeoutId != null) {
      clearTimeout(this.timeoutId);
    }
    if (this.expired === true) {
      return;
    }
    this.timeoutId = setTimeout(() => {
      this.expired = true;
      this.modalService.show(new MessageModal('Sessão expirada',
        'Sua sessão foi encerrada automaticamente por inatividade. ' +
        'Você será redirecionado para a tela de Pré-Processamento. ' +
        'Para continuar processando as infrações é necessário acessar esta funcionalidade novamente', false))
        .finally(() => {
          this.unlock();
          setTimeout(() => {
            this.router.navigate(['/pre-process/']);
          }, 1000);
        });
    }, 300000);
  }

  openMessageDuplicateViolation(violation) {
    this.modalService.show(new ComponentModal(MessageDuplicateViolationModalComponent, violation))
      .then(data => {
      }).catch(err => { });
  }

  isChangesPermited() {
    if (this.violationProcessed) {
      this.changesPermited = false;
    } else {
      this.changesPermited = true;
    }
  }

  resetForm() {
    this.formGroup.get('colorCode').setValue('');
    this.formGroup.get('year').setValue('');
    this.formGroup.get('brandModelCode').setValue('');
    this.formGroup.get('categoryCode').setValue('');
    this.formGroup.get('classificationCode').setValue('');
    this.formGroup.get('typeCode').setValue('');
    this.formGroup.get('cityCode').setValue('');
    this.formGroup.get('stateId').setValue('');
    this.formGroup.get('regionCode').setValue('');
    this.formGroup.get('regionId').setValue('');
    this.formGroup.get('reasonCode').setValue('');
  }

  brandModelInternal() {
    if (this.preProcessSettings != null && this.preProcessSettings.allowInputNotFoundVehicle !== true) {
      this.plateFound = false;
      this.resetForm();
      this.alertService.show(new AlertItem(
        'PlateNotFoundNotAuthorized', AlertType.warning, false, 1000));
    } else {
      this.resetForm();
      this.alertService.show(new AlertItem('PlateNotFoundAuthorized', AlertType.warning, false, 1000));
      this.getBrandInternal();
      if (this.requiredFields.includes('brandModelCode')) {
        this.brandModelService.list({ regionId: this.regionId, limit: '500' }).then(res => {
          this.brandModels = res.result;
        });
        if (this.formGroup.get('brandModelCode').value !== '') {
          document.getElementById('brandModelsCode').classList.remove('is-invalid');
          document.getElementById('brandModelCodeTextRequired').classList.add('hide');
        } else {
          document.getElementById('brandModelsCode').classList.add('is-invalid');
          document.getElementById('brandModelCodeTextRequired').classList.remove('hide');
        }
      }
    }
  }

  back() {
    this.router.navigate(['/pre-process/internalAudit']);
  }

  openHistoryPanel() {
    this.modalService.show(new ComponentModal(HistoryPanelComponent, this.violation))
      .catch(err => { });
  }
}
